import { api, buildQuery, download } from "./client";
import type { DashboardStats, ReportResult } from "./types";
import type { ActivityListParams } from "./activities";

/** Dasbor dan laporan. */

export function getDashboardStats() {
  return api.get<DashboardStats>("/dashboard/stats");
}

export function getReport(params: Omit<ActivityListParams, "page" | "perPage" | "sort" | "order">) {
  return api.get<ReportResult>(`/reports/activities${buildQuery({ ...params, format: "json" })}`);
}

/** Unduh CSV langsung dari server (Content-Disposition sudah ditetapkan). */
export async function downloadReportCsv(
  params: Omit<ActivityListParams, "page" | "perPage" | "sort" | "order">,
): Promise<void> {
  const blob = await download(`/reports/activities${buildQuery({ ...params, format: "csv" })}`);
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = "laporan-kegiatan.csv";
  document.body.append(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
